import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import {
  blackClose,
  modalCloseIcon,
  rightarrowwhite,
} from "../../../../../images";
import AutoCompleteOthers from "../../../../../components/AutoCompleteOthers/AutoCompleteOthers";
import _ from "lodash";
import CheckboxButton from "../../../../../components/CheckboxButton/CheckboxButton";
import style from "../../../../FormFiveLightTheme/Form/formfivelighttheme.module.scss";
import AutoCompleteField from "../../../../../components/AutoCompleteField/AutoCompleteField";
import config from "../../../../../config/config";
import http from "../../../../../helpers/http";
import { toast } from "react-toastify";
import ToastMsg from "../../../../../components/ToastMsg/ToastMsg";
import { useBusinessContext } from "../../../../../context/BusinessAccount/BusinessAccountState";
import "./nonMandatoryActionsV2.scss";
import Joi from "joi";
import { useAuth } from "../../../../../context/Auth/AuthState";
import useTheme from "../../../../../components/useTheme/useTheme";

const NonMandatoryActionsV2 = ({
  show,
  onHide,
  handleClose,
  globalData,
  emptyFields,
  data,
  shouldRenderField,
}) => {
  // steps states
  const auth = useAuth();

  const [currentStep, setCurrentStep] = useState(1);
  const totalSteps = 2;

  const nextStep = () => {
    if (currentStep < totalSteps) {
      setCurrentStep(currentStep + 1);
    }
  };

  const submitAndNext = async () => {
    await handleSubmit({ showToast: false }); // call API
    nextStep(); // move to step 2
  };

  const previousStep = () => {
    if (currentStep > 1) {
      setCurrentStep(currentStep - 1);
    }
  };
  // steps states closing

  const { theme } = useTheme();
  const [selectedOptions, setSelectedOptions] = useState({
    project_typology: [],
    design_styles: [],
    avg_project_budget: [],
    project_sizes: [],
    project_mimimal_fee: "",
  });
  const [autoKey, setAutoKey] = useState(1);
  const [formData, setFormData] = useState({
    project_locations: "",
    avg_project_currency: "",
    project_size_unit: "",
    project_minimal_fee_currency: "",
    project_mimimal_fee: "",
  });
  const [originalMinimalFee, setOriginalMinimalFee] = useState({
    fee: "",
    currency: "",
  });
  const [servicesData, setServicesData] = useState({});
  const [initialData, setInitialData] = useState(null);
  const baseUrl = config.api_url;
  const [pendingPayload, setPendingPayload] = useState(null);
  const BusinessContext = useBusinessContext();

  useEffect(() => {
    const initial = {
      project_locations: data?.project_location?.data || "",
      team_range: data?.team_range?.data || "",
      project_typology: data?.project_typology?.data || [],
      design_styles: data?.design_style?.data || [],
      avg_project_budget: data?.avg_project_budget?.budgets || [],
      avg_project_currency: data?.avg_project_budget?.currency || "INR",
      project_sizes: data?.project_sizes?.sizes || [],
      project_size_unit: data?.project_sizes?.unit || "sq.ft.",
      project_mimimal_fee: data?.project_mimimal_fee?.fee || "",
      project_minimal_fee_currency:
        data?.project_mimimal_fee?.currency || "INR",
    };

    // Check if any fields have all options selected

    const hasAllProjectTypology = hasAllOptions(
      initial.project_typology,
      globalData,
      "project_typology"
    );
    const hasAllDesignStyles = hasAllOptions(
      initial.design_styles,
      globalData,
      "design_styles"
    );

    // If all options are selected, replace with just "All"

    if (hasAllProjectTypology) {
      initial.project_typology = ["All"];
    }

    if (hasAllDesignStyles) {
      initial.design_styles = ["All"];
    }

    setInitialData(initial);

    setOriginalMinimalFee({
      fee: data?.project_mimimal_fee?.fee || "",
      currency: data?.project_mimimal_fee?.currency || "INR",
    });

    setFormData({
      project_locations: initial.project_locations,
      team_range: initial.team_range,
      avg_project_currency: initial.avg_project_currency,
      project_size_unit: initial.project_size_unit,
      project_minimal_fee_currency: initial.project_minimal_fee_currency,
      project_mimimal_fee: initial.project_mimimal_fee,
    });

    setSelectedOptions({
      project_typology: [],
      design_styles: [],
      avg_project_budget: [],
      project_sizes: [],
    });

    // Add "All" option to each array and sort them (CHANGE #2)
    // Ensure globalData fields exist with "All" option
    if (globalData) {
      // Add "All" to project_scope_preferences if not exists

      // Add "All" to project_typologies if not exists
      if (
        globalData.project_typologies &&
        !globalData.project_typologies.some(
          (item) => item.toLowerCase() === "all"
        )
      ) {
        globalData.project_typologies = [
          ...globalData.project_typologies,
          "All",
        ];
      }

      // Add "All" to design_styles if not exists
      if (
        globalData.design_styles &&
        !globalData.design_styles.some((item) => item.toLowerCase() === "all")
      ) {
        globalData.design_styles = [...globalData.design_styles, "All"];
      }
    }

    const projectTypologyOptions =
      globalData?.project_typologies?.map((it) => ({
        label: it,
        value: it,
      })) || [];

    const designStylesOptions =
      globalData?.design_styles?.map((it) => ({
        label: it,
        value: it,
      })) || [];

    setServicesData({
      project_typology: sortOptionsWithAllAtEnd(projectTypologyOptions),
      design_styles: sortOptionsWithAllAtEnd(designStylesOptions),
      budgets:
        globalData?.average_budget?.map((it) => ({
          label: it.budget,
          value: it.budget,
          currency: it.currency,
        })) || [],
      sizes:
        globalData?.project_sizes?.map((it) => ({
          label: `${it.size} ${it.unit}`,
          value: it.size,
          unit: it.unit,
        })) || [],
      minimal_fee:
        globalData?.minimum_project_fee?.map((it) => ({
          label: it,
          value: it,
        })) || [],
    });
  }, [data, show, globalData]);

  useEffect(() => {
    if (!show && pendingPayload) {
      BusinessContext.update({
        ...BusinessContext.data,
        ...pendingPayload,
      });
      setPendingPayload(null);
    }
  }, [show, pendingPayload, BusinessContext]);

  useEffect(() => {
    if (emptyFields.length === 0) {
      handleClose();
    }
    if (initialData && servicesData && Object.keys(servicesData).length > 0) {
      const updatedServicesData = { ...servicesData };
      let needsUpdate = false;

      const disableInitialOptions = (fieldName, dataField) => {
        const items = initialData[fieldName] || [];
        if (items.length === 0) return false;

        const updatedOptions = [...updatedServicesData[dataField]];
        let fieldUpdated = false;

        items.forEach((item) => {
          const index = _.findIndex(updatedOptions, { value: item });
          if (index !== -1 && !updatedOptions[index].disabled) {
            updatedOptions[index] = {
              ...updatedOptions[index],
              disabled: true,
            };
            fieldUpdated = true;
          }
        });

        if (fieldUpdated) {
          updatedServicesData[dataField] = updatedOptions;
          return true;
        }
        return false;
      };

      // Process each field and track if any updates were needed
      needsUpdate =
        disableInitialOptions("project_typology", "project_typology") ||
        needsUpdate;
      needsUpdate =
        disableInitialOptions("design_styles", "design_styles") || needsUpdate;

      // Handle budget options
      if (
        initialData.avg_project_budget &&
        initialData.avg_project_budget.length > 0
      ) {
        const updatedBudgets = [...updatedServicesData.budgets];
        let budgetsUpdated = false;

        initialData.avg_project_budget.forEach((budget) => {
          const index = _.findIndex(updatedBudgets, { value: budget });
          if (index !== -1 && !updatedBudgets[index].disabled) {
            updatedBudgets[index] = {
              ...updatedBudgets[index],
              disabled: true,
            };
            budgetsUpdated = true;
          }
        });

        if (budgetsUpdated) {
          updatedServicesData.budgets = updatedBudgets;
          needsUpdate = true;
        }
      }

      // Handle sizes options
      if (initialData.project_sizes && initialData.project_sizes.length > 0) {
        const updatedSizes = [...updatedServicesData.sizes];
        let sizesUpdated = false;

        initialData.project_sizes.forEach((size) => {
          const index = _.findIndex(updatedSizes, { value: size });
          if (index !== -1 && !updatedSizes[index].disabled) {
            updatedSizes[index] = {
              ...updatedSizes[index],
              disabled: true,
            };
            sizesUpdated = true;
          }
        });

        if (sizesUpdated) {
          updatedServicesData.sizes = updatedSizes;
          needsUpdate = true;
        }
      }

      // Only update state if something actually changed
      if (needsUpdate) {
        setServicesData((prevData) => {
          return JSON.stringify(prevData) !==
            JSON.stringify(updatedServicesData)
            ? updatedServicesData
            : prevData;
        });
      }
    }
    // Add this ref to prevent the infinite loop
  }, [initialData, emptyFields]); // Only depend on initialData, not servicesData

  useEffect(() => {
    const fetchCurrencyValues = async () => {
      if (
        formData.project_minimal_fee_currency &&
        formData.project_minimal_fee_currency !== "INR"
      ) {
        try {
          const response = await http.get(`${baseUrl}/business/get-currency`);
          if (response?.data) {
            const updatedMinimalFee = response.data.map((fee) => ({
              label: fee,
              value: fee,
            }));

            setServicesData((prev) => ({
              ...prev,
              minimal_fee: updatedMinimalFee,
            }));
          }
        } catch (error) {
          console.error("Error fetching currency values:", error);
        }
      } else {
        const defaultMinimalFee =
          globalData?.minimum_project_fee?.map((fee) => ({
            label: fee,
            value: fee,
          })) || [];

        setServicesData((prev) => ({
          ...prev,
          minimal_fee: defaultMinimalFee,
        }));
      }
    };

    if (formData.project_minimal_fee_currency) {
      fetchCurrencyValues();
    }
  }, [formData.project_minimal_fee_currency, baseUrl, globalData]);

  const sortOptionsWithAllAtEnd = (options) => {
    if (!options || !Array.isArray(options)) return [];

    return [...options].sort((a, b) => {
      if (a.value.toLowerCase() === "all") return 1;
      if (b.value.toLowerCase() === "all") return -1;
      return a.value.localeCompare(b.value);
    });
  };

  const hasAllOptions = (data, globalData, fieldName) => {
    if (!data || !globalData) return false;

    const dataField = {
      project_typology: "project_typologies",
      design_styles: "design_styles",
    }[fieldName];

    if (!dataField || !globalData[dataField]) return false;

    // If "all" is explicitly included
    if (data.some((item) => item.toLowerCase() === "all")) return true;

    // Or if all options are included (excluding "all")
    const globalOptions = globalData[dataField].filter(
      (opt) => opt.toLowerCase() !== "all"
    );
    return (
      globalOptions.length > 0 &&
      globalOptions.every((opt) =>
        data.some((item) => item.toLowerCase() === opt.toLowerCase())
      )
    );
  };

  const handleOptionChange = (value, field) => {
    // If "All" is selected
    if (value.toLowerCase() === "all") {
      // Clear all previous selections
      setSelectedOptions((prev) => ({
        ...prev,
        [field]: ["All"],
      }));

      // Disable only the "All" option
      const updatedOptions = [...servicesData[field]].map((option) => ({
        ...option,
        disabled: option.value.toLowerCase() === "all",
      }));

      setServicesData((prev) => ({
        ...prev,
        [field]: updatedOptions,
      }));

      return;
    }

    // For any other option, handle both explicit "All" and implicit "all" (when all options are selected)
    const currentSelections = [...selectedOptions[field]];

    // Check for explicit "All" in selectedOptions
    const allOptionIndex = currentSelections.findIndex(
      (option) => option.toLowerCase() === "all"
    );

    // Check for implicit "all" in initialData (all options are selected)
    const hasAllInInitial = hasAllOptions(
      initialData[field],
      globalData,
      field
    );

    // If "All" was previously selected or all options were implicitly selected
    if (allOptionIndex !== -1 || hasAllInInitial) {
      // If explicit "All" was selected, remove it
      if (allOptionIndex !== -1) {
        currentSelections.splice(allOptionIndex, 1);
      }

      // If all options were implicitly selected in initialData, clear initialData for this field
      if (hasAllInInitial) {
        setInitialData((prev) => ({
          ...prev,
          [field]: [], // Clear the initialData for this field
        }));
      }

      // Enable the "All" option in dropdown
      const updatedOptions = [...servicesData[field]].map((option) => ({
        ...option,
        disabled:
          (option.value.toLowerCase() !== "all" && option.value === value) ||
          (option.value.toLowerCase() !== "all" &&
            !hasAllInInitial && // Don't keep disabled if we just cleared initialData
            initialData[field] &&
            initialData[field].includes(option.value)),
      }));

      setServicesData((prev) => ({
        ...prev,
        [field]: updatedOptions,
      }));
    }

    // Normal case - adding a regular option
    enableDisableOption(value, true, field);
    setSelectedOptions((prev) => ({
      ...prev,
      [field]: [...currentSelections, value],
    }));
  };

  const handleCheckboxChange = (index, value, field) => {
    if (value.toLowerCase() === "all") {
      // Re-enable all options if "All" is deselected
      const updatedOptions = [...servicesData[field]].map((option) => ({
        ...option,
        disabled:
          initialData[field] && initialData[field].includes(option.value),
      }));

      setServicesData((prev) => ({
        ...prev,
        [field]: updatedOptions,
      }));
    } else {
      enableDisableOption(value, false, field);
    }

    const updatedOptions = [...selectedOptions[field]];
    updatedOptions.splice(index, 1);
    setSelectedOptions((prev) => ({
      ...prev,
      [field]: updatedOptions,
    }));
  };

  const enableDisableOption = (value, isDisabled, field) => {
    const fieldMapping = {
      project_typology: "project_typology",
      design_styles: "design_styles",
      avg_project_budget: "budgets",
      project_sizes: "sizes",
    };

    const dataField = fieldMapping[field] || field;

    if (!servicesData[dataField] || !Array.isArray(servicesData[dataField])) {
      console.error(
        `servicesData[${dataField}] is not an array or doesn't exist`
      );
      return;
    }

    // Find the item to update
    const selectedIndex = _.findIndex(servicesData[dataField], { value });
    if (selectedIndex === -1) {
      console.error(`Option with value ${value} not found in ${dataField}`);
      return;
    }

    // For sizes and budgets, only apply changes if the current unit/currency matches
    if (
      dataField === "sizes" &&
      servicesData[dataField][selectedIndex].unit !== formData.project_size_unit
    ) {
      return;
    }

    if (
      dataField === "budgets" &&
      servicesData[dataField][selectedIndex].currency !==
        formData.avg_project_currency
    ) {
      return;
    }

    const updatedOptions = [...servicesData[dataField]];
    updatedOptions[selectedIndex] = {
      ...updatedOptions[selectedIndex],
      disabled: isDisabled,
    };

    setServicesData((prev) => ({
      ...prev,
      [dataField]: updatedOptions,
    }));
  };

  const resetDisabledState = (dataField) => {
    if (!servicesData[dataField]) return;

    const updatedOptions = servicesData[dataField].map((option) => {
      // Only enable options that were disabled by user selection, not those from initialData
      const isInInitialData =
        dataField === "budgets"
          ? initialData.avg_project_budget.includes(option.value)
          : initialData.project_sizes.includes(option.value);

      // Keep initial data options disabled, but enable user-selected ones
      return {
        ...option,
        disabled: isInInitialData,
      };
    });

    setServicesData((prev) => ({
      ...prev,
      [dataField]: updatedOptions,
    }));
  };

  const handleSelectChange = (value, field) => {
    if (field === "project_size_unit" && value !== formData.project_size_unit) {
      setSelectedOptions((prev) => ({
        ...prev,
        project_sizes: [],
      }));

      resetDisabledState("sizes");
    }

    if (
      field === "avg_project_currency" &&
      value !== formData.avg_project_currency
    ) {
      setSelectedOptions((prev) => ({
        ...prev,
        avg_project_budget: [],
      }));

      resetDisabledState("budgets");
    }

    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const getDataFieldName = (field) => {
    const dataFieldMap = {
      project_typology: "project_typologies",
      design_styles: "design_styles",
    };
    return dataFieldMap[field] || field;
  };

  const handleRemove = (value, field) => {
    // If removing "All" option
    if (value.toLowerCase() === "all") {
      // Re-enable all options
      const updatedOptions = [...servicesData[field]].map((option) => ({
        ...option,
        disabled: false,
      }));

      setServicesData((prev) => ({
        ...prev,
        [field]: updatedOptions,
      }));
    }

    // Check if we're removing from an implicit "All" (all options selected)
    const hasAllOptionsBeforeRemoval = hasAllOptions(
      initialData[field],
      globalData,
      field
    );

    // Remove the specific value from initialData
    const updatedData = initialData[field].filter((item) => item !== value);

    setInitialData((prev) => ({
      ...prev,
      [field]: updatedData,
    }));

    // If we were removing from an implicit "All" state and this is the first removal,
    // we need to repopulate with all other options except the one being removed and "All"
    if (hasAllOptionsBeforeRemoval && value.toLowerCase() !== "all") {
      // Get all options except "All" and the one being removed
      const allFieldOptions =
        globalData[getDataFieldName(field)]?.filter(
          (opt) => opt.toLowerCase() !== "all" && opt !== value
        ) || [];

      // Update initialData with all options except the removed one
      setInitialData((prev) => ({
        ...prev,
        [field]: allFieldOptions,
      }));

      // Update servicesData to reflect these changes
      const updatedOptions = [...servicesData[field]].map((option) => ({
        ...option,
        disabled:
          option.value.toLowerCase() === "all" ||
          (option.value !== value && allFieldOptions.includes(option.value)),
      }));

      setServicesData((prev) => ({
        ...prev,
        [field]: updatedOptions,
      }));
    } else if (value.toLowerCase() !== "all") {
      // Normal case - just enable the removed option
      enableDisableOption(value, false, field);
    }
  };

  const handleSubmit = async ({
    closeAfterSave = false,
    showToast = true,
  } = {}) => {
    try {
      // Helper function to handle "All" option in arrays
      const processFieldWithAllOption = (fieldName, dataField) => {
        const selectedAll = [
          ...initialData[fieldName],
          ...selectedOptions[fieldName],
        ].some((item) => item.toLowerCase() === "all");

        if (selectedAll) {
          // Return all options from globalData except "All" itself
          return (
            globalData[dataField]?.filter(
              (item) => item.toLowerCase() !== "all"
            ) || []
          );
        }

        // Return normal combined selections
        return [
          ...initialData[fieldName],
          ...selectedOptions[fieldName],
        ].filter((item) => item.toLowerCase() !== "all");
      };

      const payload = {
        project_location: { data: formData.project_locations },
        team_range: { data: formData.team_range },

        project_typology: {
          data: processFieldWithAllOption(
            "project_typology",
            "project_typologies"
          ),
        },
        design_style: {
          data: processFieldWithAllOption("design_styles", "design_styles"),
        },
        avg_project_budget: {
          budgets: [
            ...(initialData?.avg_project_currency ===
            formData.avg_project_currency
              ? [
                  ...initialData.avg_project_budget,
                  ...selectedOptions.avg_project_budget,
                ]
              : [...selectedOptions.avg_project_budget]),
          ],
          currency: formData.avg_project_currency,
        },
        project_sizes: {
          sizes: [
            ...(initialData?.project_size_unit === formData.project_size_unit
              ? [...initialData.project_sizes, ...selectedOptions.project_sizes]
              : [...selectedOptions.project_sizes]),
          ],
          unit: formData.project_size_unit,
        },
        project_mimimal_fee: {
          fee: formData.project_mimimal_fee,
          currency: formData.project_minimal_fee_currency,
        },
      };

      const response = await http.post(
        `${baseUrl}/business/business-details/${BusinessContext?.data?._id}`,
        payload
      );

      if (response?.data) {
        setPendingPayload(payload);
        // BusinessContext.update({
        //   ...BusinessContext.data,
        //   ...payload,
        // });
        // toast(
        //   <ToastMsg message={`Changes Saved Successfully`} />,
        //   config.success_toast_config
        // );
        if (showToast) {
          // toast(
          //   <ToastMsg message="Changes Saved Successfully" />,
          //   config.success_toast_config
          // );
          window.dispatchEvent(new Event("saveSuccess"));
        }

        // ONLY CLOSE MODAL WHEN REQUIRED
        if (closeAfterSave) {
          handleClose();
        }
      }
      // await api.saveData(payload);
      // handleClose();
    } catch (error) {
      console.error("Error saving data:", error);
    }
  };

  const handleModalClose = () => {
    // Revert to initial data
    setFormData({
      project_locations: initialData?.project_locations || "",
      team_range: initialData?.team_range || "",
      avg_project_currency: initialData?.avg_project_currency || "",
      project_size_unit: initialData?.project_size_unit || "",
      project_minimal_fee_currency:
        initialData?.project_minimal_fee_currency || "",
      project_mimimal_fee: initialData?.project_mimimal_fee || "",
    });
    setSelectedOptions({
      project_typology: [],
      design_styles: [],
      avg_project_budget: [],
      project_sizes: [],
      project_mimimal_fee: "",
    });
    handleClose();
  };

  // Filter budgets based on selected currency
  const filteredBudgets = servicesData?.budgets?.filter(
    (budget) => budget.currency === formData.avg_project_currency
  );

  // Filter sizes based on selected unit
  const filteredSizes = servicesData?.sizes?.filter(
    (size) => size.unit === formData.project_size_unit
  );

  // Add these two render functions before the return statement

  const renderBudgetSection = () => {
    const selectedList = selectedOptions.avg_project_budget.map((option, i) => (
      <CheckboxButton
        lightTheme={theme === "light"}
        isChecked={true}
        label={option}
        labelId={option}
        onChange={() => handleCheckboxChange(i, option, "avg_project_budget")}
        key={`budget-${i}`}
      />
    ));

    return (
      <div className="excel_select_search_wrapper">
        <div className={`${style.steps} ${style.fastep04}`}>
          <div className={`${style.add_more_wrap} ${style.add_more_v2}`}>
            <div className={`${style.field_wrapper} field_wrapper`}>
              <ul className="checkboxes chips_b_edit_autoComplete">
                {formData.avg_project_currency ===
                  initialData?.avg_project_currency &&
                  initialData?.avg_project_budget?.map((value, index) => (
                    <li
                      className="black_border_chips_custom"
                      key={`budget-chip-${index}`}
                      onClick={() => handleRemove(value, "avg_project_budget")}
                    >
                      {value}
                      <img
                        src={blackClose}
                        alt="close"
                        className="close_icon"
                      />
                    </li>
                  ))}
                {selectedList}
              </ul>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const renderProjectSizesSection = () => {
    const selectedList = selectedOptions.project_sizes.map((option, i) => (
      <CheckboxButton
        lightTheme={theme === "light"}
        isChecked={true}
        label={`${option} ${formData.project_size_unit}`}
        labelId={option}
        onChange={() => handleCheckboxChange(i, option, "project_sizes")}
        key={`size-${i}`}
      />
    ));

    return (
      <div className="excel_select_search_wrapper">
        <div className={`${style.steps} ${style.fastep04}`}>
          <div className={`${style.add_more_wrap} ${style.add_more_v2}`}>
            <div className={`${style.field_wrapper} field_wrapper`}>
              <ul className="checkboxes chips_b_edit_autoComplete">
                {formData.project_size_unit ===
                  initialData?.project_size_unit &&
                  initialData?.project_sizes?.map((value, index) => (
                    <li
                      className="black_border_chips_custom"
                      key={`size-chip-${index}`}
                      onClick={() => handleRemove(value, "project_sizes")}
                    >
                      {value} {data.project_sizes.unit}
                      <img
                        src={blackClose}
                        alt="close"
                        className="close_icon"
                      />
                    </li>
                  ))}
                {selectedList}
              </ul>
            </div>
          </div>
        </div>
      </div>
    );
  };

  // Updated Project Typology section render function
  const renderProjectTypologySection = () => {
    const selectedList = selectedOptions.project_typology.map((option, i) => (
      <CheckboxButton
        lightTheme={theme === "light"}
        isChecked={true}
        label={option}
        labelId={option}
        onChange={() => handleCheckboxChange(i, option, "project_typology")}
        key={`typology-${i}`}
      />
    ));

    // Don't show other options if "All" is selected in either initialData or selectedOptions
    const hasAllInInitial = initialData?.project_typology?.some(
      (item) => item.toLowerCase() === "all"
    );
    const hasAllInSelected = selectedOptions.project_typology?.some(
      (item) => item.toLowerCase() === "all"
    );

    return (
      <div className="excel_select_search_wrapper">
        <div className={`${style.steps} ${style.fastep04}`}>
          <div className={`${style.add_more_wrap} ${style.add_more_v2}`}>
            <div className={`${style.field_wrapper} field_wrapper`}>
              <div className="search_select_wrapper auto_complete_field--non-mandatory auto_complete_field--non-mandatory--typology">
                <AutoCompleteOthers
                  key={`autokey${autoKey}-project_typology`}
                  lightTheme={theme === "light"}
                  textLabel="Which types of projects does your business work on?"
                  data={servicesData["project_typology"]}
                  onChange={(e, value) => {
                    handleOptionChange(value.value, "project_typology");
                    setAutoKey((prev) => prev + 1);
                  }}
                />
                {/* <div className="error_wrapper">
                  <p className="error">Error msg</p>
                </div> */}
              </div>
              <ul className="checkboxes chips_b_edit_autoComplete">
                {initialData?.project_typology?.map((value, index) => (
                  <li
                    className="black_border_chips_custom"
                    key={`typology-chip-${index}`}
                    onClick={() => handleRemove(value, "project_typology")}
                  >
                    {value}
                    <img src={blackClose} alt="close" className="close_icon" />
                  </li>
                ))}
                {selectedList}
              </ul>
            </div>
          </div>
        </div>
      </div>
    );
  };

  // Updated Design Styles section render function
  const renderDesignStylesSection = () => {
    const selectedList = selectedOptions.design_styles.map((option, i) => (
      <CheckboxButton
        lightTheme={theme === "light"}
        isChecked={true}
        label={option}
        labelId={option}
        onChange={() => handleCheckboxChange(i, option, "design_styles")}
        key={`style-${i}`}
      />
    ));

    // Don't show other options if "All" is selected in either initialData or selectedOptions
    const hasAllInInitial = initialData?.design_styles?.some(
      (item) => item.toLowerCase() === "all"
    );
    const hasAllInSelected = selectedOptions.design_styles?.some(
      (item) => item.toLowerCase() === "all"
    );

    return (
      <div className="excel_select_search_wrapper">
        <div className={`${style.steps} ${style.fastep04}`}>
          <div className={`${style.add_more_wrap} ${style.add_more_v2}`}>
            <div className={`${style.field_wrapper} field_wrapper`}>
              <div className="search_select_wrapper auto_complete_field--non-mandatory">
                <AutoCompleteOthers
                  key={`autokey${autoKey}-design_styles`}
                  lightTheme={theme === "light"}
                  textLabel="What are the Design Styles that your Business can work for?"
                  data={servicesData["design_styles"]}
                  onChange={(e, value) => {
                    handleOptionChange(value.value, "design_styles");
                    setAutoKey((prev) => prev + 1);
                  }}
                />
                {/* <div className="error_wrapper">
                  <p className="error">Error msg</p>
                </div> */}
              </div>
              <ul className="checkboxes chips_b_edit_autoComplete">
                {initialData?.design_styles?.map((value, index) => (
                  <li
                    className="black_border_chips_custom"
                    key={`style-chip-${index}`}
                    onClick={() => handleRemove(value, "design_styles")}
                  >
                    {value}
                    <img src={blackClose} alt="close" className="close_icon" />
                  </li>
                ))}
                {selectedList}
              </ul>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const fieldRenderMap = {
    project_location: "location_preference",
    team_range: "team_members",
    design_style: "service_design_style",
    avg_project_budget: "average_budget",
    project_sizes: "minimum_project_size",
    project_mimimal_fee: "current_minimal_fee",
    project_typology: "project_typology",
  };

  const visibleEmptyFields = React.useMemo(() => {
    return (emptyFields || []).filter((field) => {
      const renderKey = fieldRenderMap[field];
      return renderKey && shouldRenderField(renderKey);
    });
  }, [emptyFields, shouldRenderField]);

  // console.table(
  //   emptyFields.map((field) => {
  //     const renderKey = fieldRenderMap[field];
  //     return {
  //       field,
  //       renderKey,
  //       shouldRender: renderKey ? shouldRenderField(renderKey) : false,
  //     };
  //   })
  // );

  // console.log("Auth", auth);

  // console.log("GLOBAL DATA:", globalData);

  // validation for future if all field get required

  // const projectLocationSchema = Joi.object({
  //   data: Joi.string().required(),
  // });

  // const teamRangeSchema = Joi.object({
  //   data: Joi.string().required(),
  // });

  // const projectTypologySchema = Joi.object({
  //   data: Joi.array().items(Joi.string()).min(1).required(),
  // });

  // const designStyleSchema = Joi.object({
  //   data: Joi.array().items(Joi.string()).min(1).required(),
  // });

  // const avgProjectBudgetSchema = Joi.object({
  //   budgets: Joi.array().items(Joi.string()).min(1).required(),
  //   currency: Joi.string().required(),
  // });

  // const projectSizesSchema = Joi.object({
  //   sizes: Joi.array().items(Joi.string()).min(1).required(),
  //   unit: Joi.string().required(),
  // });

  // const projectMinimalFeeSchema = Joi.object({
  //   fee: Joi.string().required(),
  // currency: Joi.string().required(),
  // });

  // const nonMandatorySchema = Joi.object({
  //   project_location: projectLocationSchema.required(),
  //   team_range: teamRangeSchema.required(),
  //   project_typology: projectTypologySchema.required(),
  //   design_style: designStyleSchema.required(),
  //   avg_project_budget: avgProjectBudgetSchema.required(),
  //   project_sizes: projectSizesSchema.required(),
  //   project_mimimal_fee: projectMinimalFeeSchema.required(),
  // });

  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      className={`excel_popup non-mandatory--modal  ${
        theme === "dark" && "non-mandatory--modal-dark-mode"
      }`}
      backdropClassName={`custom-backdrop ${theme === "dark" && "custom-backdrop-dark-non-mandatory"}`}
    >
      <Modal.Header>
        <button
          className="custom-cancel-btn cancel_cta--non-mandatory"
          onClick={handleClose}
        >
          <img
            src={modalCloseIcon}
            alt="close-icon"
            className="ctm_img_bussine_edit_about"
          />
        </button>
      </Modal.Header>
      <Modal.Body>
        <h2 className="about_modal_bussines_heading heading_non_menditaroy">
          {/* Complete {emptyFields?.length} Actions */}
          Complete {visibleEmptyFields.length} Actions
        </h2>

        {/* Step Indicator */}
        <div className={`non-mandatory-step-wizard ${theme === "dark" ? "non-mandatory-step-wizard--dark-mode" : ""}`}>
          <div className="step-indicator-wrapper">
            <div className="step-indicator">
              <div className="step-line">
                <div
                  className="step-line-progress"
                  style={{ width: currentStep === 1 ? "20%" : "100%" }}
                ></div>
              </div>

              <div
                className={`step-item ${currentStep >= 1 ? "completed" : ""} ${
                  currentStep === 1 ? "active" : ""
                }`}
              >
                <div className="step-circle">
                  {currentStep > 1 ? (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="#014fe0"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      class="lucide lucide-check-icon lucide-check"
                    >
                      <path d="M20 6 9 17l-5-5" />
                    </svg>
                  ) : (
                    "01"
                  )}
                </div>
                <div className="step-info">
                  <div className="step-number">Step 1</div>
                </div>
              </div>

              <div
                className={`step-item ${currentStep >= 2 ? "completed" : ""} ${
                  currentStep === 2 ? "active" : ""
                }`}
              >
                <div className="step-circle">
                  {currentStep > 2 ? (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="#014fe0"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      class="lucide lucide-check-icon lucide-check"
                    >
                      <path d="M20 6 9 17l-5-5" />
                    </svg>
                  ) : (
                    "02"
                  )}
                </div>
                <div className="step-info">
                  <div className="step-number">Step 2</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <form
          onSubmit={(e) => {
            e.preventDefault();
          }}
        >
          {currentStep === 1 && (
            <div className="step-content">
              <h3 className="about_modal_bussines_heading heading_non_menditaroy sub_heading--non-mandatory">
                About Your Business/ Firm
              </h3>

              <div className="excel_select_container overflow_cmpActions padding_cmpActions">
                {/* Can do Projects */}
                {/* {emptyFields?.includes("project_location") && ( */}
                {shouldRenderField("location_preference") && (
                  <div className="excel_select_wrapper auto_complete_field--non-mandatory w-mb-100">
                    <AutoCompleteField
                       lightTheme={theme === "light"}
                      key="project_locations"
                      textLabel="Project/ Client location preference"
                      data={
                        globalData?.project_locations?.map((it) => ({
                          label: it,
                          value: it,
                        })) || []
                      }
                      value={
                        globalData?.project_locations
                          ?.map((it) => ({
                            label: it,
                            value: it,
                          }))
                          .find(
                            (option) =>
                              option.value === formData.project_locations
                          ) || null
                      }
                      onChange={(e, option) =>
                        handleSelectChange(
                          option?.value || "",
                          "project_locations"
                        )
                      }
                    />
                    {/* <div className="error_wrapper">
                      <p className="error">Error msg</p>
                    </div> */}
                  </div>
                )}
                {/* )} */}

                {/* {emptyFields?.includes("team_range") && ( */}
                {shouldRenderField("team_members") && (
                  <div className="excel_select_wrapper auto_complete_field--non-mandatory w-mb-100">
                    <AutoCompleteField
                      lightTheme={theme === "light"}
                      key="team_range"
                      textLabel="Number of Team Members"
                      data={
                        globalData?.team_member_ranges?.map((it) => ({
                          label: it,
                          value: it,
                        })) || []
                      }
                      value={
                        globalData?.team_member_ranges
                          ?.map((it) => ({
                            label: it,
                            value: it,
                          }))
                          .find(
                            (option) => option.value === formData.team_range
                          ) || null
                      }
                      onChange={(e, option) =>
                        handleSelectChange(option?.value || "", "team_range")
                      }
                    />
                    {/* <div className="error_wrapper">
                      <p className="error">Error msg</p>
                    </div> */}
                  </div>
                )}
                {/* )} */}

                {renderDesignStylesSection()}
               
              </div>
               <button
                  className="popup_common_btn align-items-center popup_common_btn--next "
                  // onClick={nextStep}
                  onClick={submitAndNext}
                >
                  Save & Next{" "}
                  <img
                    src={rightarrowwhite}
                    alt="next"
                    className="next_arr--step"
                  />
                </button>
            </div>
          )}

          {/* Step 2 */}
          {currentStep === 2 && (
            <div className="step-content">
              <h3 className="about_modal_bussines_heading heading_non_menditaroy sub_heading--non-mandatory">
                About Your Projects
              </h3>
              <p className="note--msg">This information is only for Archinza AI matchmaking and won’t be displayed on your business profile.</p>
              <div className="excel_select_container overflow_cmpActions">
                {/* {emptyFields?.includes("avg_project_budget") && ( */}
                {shouldRenderField("average_budget") && (
                  <>
                    <div className="excel_select2field_wrapper">
                      <div className="excel_select_wrapper mb-0 auto_complete_field--non-mandatory">
                        <AutoCompleteOthers
                          lightTheme={theme === "light"}
                          key={`autokey${autoKey}-avg_project_budget`}
                          textLabel="Approx Budget of Projects"
                          data={filteredBudgets}
                          onChange={(e, value) => {
                            handleOptionChange(
                              value.value,
                              "avg_project_budget"
                            );
                            setAutoKey((prev) => prev + 1);
                          }}
                          allowAddOption={false}
                        />
                        {/* <div className="error_wrapper">
                          <p className="error">Error msg</p>
                        </div> */}
                      </div>
                      <div className="excel_select_wrapper mb-0 w-custom">
                        <AutoCompleteField
                          lightTheme={theme === "light"}
                          key="avg_project_currency"
                          textLabel="Currency"
                          data={
                            _.uniqBy(
                              globalData?.average_budget,
                              "currency"
                            )?.map((item) => ({
                              label: item.currency,
                              value: item.currency,
                            })) || []
                          }
                          value={
                            _.uniqBy(globalData?.average_budget, "currency")
                              ?.map((item) => ({
                                label: item.currency,
                                value: item.currency,
                              }))
                              .find(
                                (option) =>
                                  option.value === formData.avg_project_currency
                              ) || null
                          }
                          onChange={(e, option) =>
                            handleSelectChange(
                              option?.value || "",
                              "avg_project_currency"
                            )
                          }
                        />{" "}
                        {/* <div className="error_wrapper">
                          <p className="error">Error msg</p>
                        </div> */}
                      </div>
                    </div>
                    {renderBudgetSection()}
                  </>
                )}
                {/* )} */}
                {/* {emptyFields?.includes("project_sizes") && ( */}
                {shouldRenderField("minimum_project_size") && (
                  <>
                    <div className="excel_select2field_wrapper">
                      <div className="excel_select_wrapper mb-0 auto_complete_field--non-mandatory">
                        <AutoCompleteOthers
                          lightTheme={theme === "light"}
                          key={`autokey${autoKey}-project_sizes`}
                          textLabel="Minimum Project Size"
                          data={filteredSizes}
                          onChange={(e, value) => {
                            handleOptionChange(value.value, "project_sizes");
                            setAutoKey((prev) => prev + 1);
                          }}
                          allowAddOption={false}
                        />
                        {/* <div className="error_wrapper">
                          <p className="error">Error msg</p>
                        </div> */}
                      </div>
                      <div className="excel_select_wrapper mb-0 auto_complete_field--non-mandatory w-custom">
                        <AutoCompleteField
                          lightTheme={theme === "light"}
                          key="project_size_unit"
                          textLabel="Unit"
                          data={
                            _.uniqBy(globalData?.project_sizes, "unit")?.map(
                              (item) => ({
                                label: item.unit,
                                value: item.unit,
                              })
                            ) || []
                          }
                          value={
                            _.uniqBy(globalData?.project_sizes, "unit")
                              ?.map((item) => ({
                                label: item.unit,
                                value: item.unit,
                              }))
                              .find(
                                (option) =>
                                  option.value === formData.project_size_unit
                              ) || null
                          }
                          onChange={(e, option) =>
                            handleSelectChange(
                              option?.value || "",
                              "project_size_unit"
                            )
                          }
                        />
                        {/* <div className="error_wrapper">
                          <p className="error">Error msg</p>
                        </div> */}
                      </div>
                    </div>
                    {renderProjectSizesSection()}
                  </>
                )}
                {/* )} */}
                {/* Current Minimum Project Sizes */}
                {/* {emptyFields?.includes("project_mimimal_fee") && ( */}
                {shouldRenderField("current_minimal_fee") && (
                  <div className="excel_select2field_wrapper">
                    <div className="excel_select_wrapper mb-0 auto_complete_field--non-mandatory">
                      <AutoCompleteField
                        lightTheme={theme === "light"}
                        key={`minimal_fee`}
                        textLabel="Current Minimum Project Fee"
                        data={servicesData.minimal_fee || []}
                        value={
                          formData.project_mimimal_fee
                            ? {
                                label: formData.project_mimimal_fee,
                                value: formData.project_mimimal_fee,
                              }
                            : null
                        }
                        onChange={(e, option) => {
                          if (option) {
                            setFormData((prev) => ({
                              ...prev,
                              project_mimimal_fee: option.value,
                            }));
                          } else {
                            setFormData((prev) => ({
                              ...prev,
                              project_mimimal_fee: "",
                            }));
                          }
                        }}
                      />
                      {/* <div className="error_wrapper">
                        <p className="error">Error msg</p>
                      </div> */}
                    </div>
                    <div className="excel_select_wrapper mb-0 auto_complete_field--non-mandatory w-custom">
                      <AutoCompleteField
                        lightTheme={theme === "light"}
                        key="project_minimal_fee_currency"
                        textLabel="Currency"
                        data={[
                          { label: "INR", value: "INR" },
                          { label: "USD", value: "USD" },
                        ]}
                        value={
                          formData.project_minimal_fee_currency
                            ? {
                                label: formData.project_minimal_fee_currency,
                                value: formData.project_minimal_fee_currency,
                              }
                            : null
                        }
                        onChange={(e, option) => {
                          if (option) {
                            if (option.value === originalMinimalFee.currency) {
                              setFormData((prev) => ({
                                ...prev,
                                project_minimal_fee_currency: option.value,
                                project_mimimal_fee: originalMinimalFee.fee,
                              }));
                            } else {
                              setFormData((prev) => ({
                                ...prev,
                                project_minimal_fee_currency: option.value,
                                project_mimimal_fee: "",
                              }));
                            }
                          }
                        }}
                      />
                      {/* <div className="error_wrapper">
                        <p className="error">Error msg</p>
                      </div> */}
                    </div>
                  </div>
                )}
                {/* )} */}
                {renderProjectTypologySection()}
              </div>
              <div className="cta_submit_back--wrapper d-flex">
                <button
                  // type="submit"
                  type="button"
                  className="popup_common_btn"
                  // onClick={handleSubmit}
                  onClick={() =>
                    handleSubmit({ closeAfterSave: true, showToast: true })
                  }
                >
                  Save Changes
                </button>{" "}
                <button className="txt_back--nmn" onClick={previousStep}>
                  Back
                </button>
              </div>
            </div>
          )}
        </form>
      </Modal.Body>
    </Modal>
  );
};

export default NonMandatoryActionsV2;
